import { render, staticRenderFns } from "./CreateSections.vue?vue&type=template&id=783f6980&scoped=true"
import script from "./CreateSections.vue?vue&type=script&lang=js"
export * from "./CreateSections.vue?vue&type=script&lang=js"
import style0 from "./CreateSections.vue?vue&type=style&index=0&id=783f6980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783f6980",
  null
  
)

export default component.exports